import { render, staticRenderFns } from "./NavSubItem.vue?vue&type=template&id=25c2c6fa"
import script from "./NavSubItem.vue?vue&type=script&lang=ts"
export * from "./NavSubItem.vue?vue&type=script&lang=ts"
import style0 from "./NavSubItem.vue?vue&type=style&index=0&id=25c2c6fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports